import { useEffect, useRef, useState } from "react";
import { Flame, Award, Zap } from "lucide-react";

function useCountUp(target, active) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!active) return;
    let frame;
    const duration = 1200;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      setValue(Math.round(progress * target));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [active, target]);
  return value;
}

export default function LandingGamification() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setActive(true); }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const xp = useCountUp(2450, active);
  const streak = useCountUp(14, active);
  const badges = useCountUp(9, active);

  return (
    <section className="py-10 sm:py-16 bg-white" data-testid="landing-gamification-section" ref={ref}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-primary">Stay Motivated</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2">Learning that feels like leveling up.</h2>
        <p className="text-xs text-muted-foreground mt-2">Example XP dashboard shown below</p>
        <div className="grid grid-cols-3 gap-4 mt-6 max-w-lg mx-auto">
          <div className="bg-card border border-border rounded-2xl p-5" data-testid="gamification-xp-stat">
            <Zap className="text-secondary mx-auto mb-2" size={22} />
            <p className="font-heading font-extrabold text-2xl">{xp.toLocaleString()}</p>
            <p className="text-xs text-muted-foreground">XP Earned</p>
          </div>
          <div className="bg-card border border-border rounded-2xl p-5" data-testid="gamification-streak-stat">
            <Flame className="text-[#E73F9A] mx-auto mb-2" size={22} />
            <p className="font-heading font-extrabold text-2xl">{streak}-day</p>
            <p className="text-xs text-muted-foreground">Streak</p>
          </div>
          <div className="bg-card border border-border rounded-2xl p-5" data-testid="gamification-badges-stat">
            <Award className="text-[#9A3DB2] mx-auto mb-2" size={22} />
            <p className="font-heading font-extrabold text-2xl">{badges}</p>
            <p className="text-xs text-muted-foreground">Badges Won</p>
          </div>
        </div>
      </div>
    </section>
  );
}
